<div
    class="mp-total-projects-card trezo-card mb-25 border-radius d-block bg-white border-0 shadow-none"
    [class.component-dark-theme]="themeService.isDark()"
>
    <div class="trezo-card-content">
        <span class="d-block">
            Total Projects
        </span>
        <h5 class="mb-0">
            22.5k+
        </h5>
        <div class="icon mx-auto text-secondary bg-secondary-100 rounded-circle mx-auto d-flex align-items-center justify-content-center">
            <i class="material-symbols-outlined">
                auto_stories
            </i>
        </div>
        <div class="info d-flex align-items-center justify-content-between">
            <span class="d-block">
                This Month
            </span>
            <span class="lh-1 text-success">
                <i class="material-symbols-outlined">
                    trending_up
                </i>
            </span>
        </div>
    </div>
</div>